import useActionReducer from '@admin/hooks/use_action_reducer'
import ImageEditor from './image_editor'
import * as selectors from './selectors'
import * as actions from './actions'
import PropTypes from 'prop-types'
import reducer from './reducer'
import React from 'react'

const ImageEditorContainer = (props) => {

  const [state, handlers] = useActionReducer({
    display_name: 'image_editor',
    actions,
    props,
    reducer,
    selectors
  })

  const mergedProps = {
    ...props,
    ...state,
    ...handlers
  }

  return <ImageEditor { ...mergedProps } />

}

ImageEditorContainer.propTypes = {}

export default ImageEditorContainer
